import { Link } from "react-router-dom";
import { FormProvider } from "react-hook-form";
import { Input, Listbox } from "@/components/ui/form";
import { Button } from "@/components/ui/button";

export const RegisterForm = ({ methods, mutation, onSubmit }) => {
    return (
        <FormProvider {...methods}>
            <form
                onSubmit={methods.handleSubmit(onSubmit)}
                className="grid grid-cols-12 gap-x-4 gap-y-3"
            >
                <div className="col-span-6">
                    <Input
                        name="firstName"
                        label="First name"
                        placeholder="First name"
                    />
                </div>
                <div className="col-span-6">
                    <Input
                        name="lastName"
                        label="Last name"
                        placeholder="Last name"
                    />
                </div>
                <div className="col-span-full">
                    <Input
                        name="email"
                        label="Email address"
                        placeholder="Email"
                    />
                </div>
                <div className="col-span-full">
                    <Input
                        name="password"
                        label="Password"
                        placeholder="Password"
                        type="password"
                    />
                </div>
                <div className="col-span-full">
                    <Listbox
                        name="claimType"
                        label="I am a ..."
                        placeholder="Patient/Clinician"
                    >
                        <option value="Patient">Patient</option>
                        <option value="Clinician">Clinician</option>
                    </Listbox>
                </div>
                <div className="col-span-full">
                    <p className="mb-1 text-sm">
                        By creating an account, you agree to our{" "}
                        <Link
                            to="/privacy"
                            className="no-underline hover:underline"
                        >
                            <strong>terms</strong>
                        </Link>
                    </p>
                </div>
                <div className="col-span-full">
                    <Button
                        type="submit"
                        id="submitRegister"
                        variant="primary"
                        className="w-full"
                        disabled={mutation.isPending}
                    >
                        {mutation.isPending ? "Registering..." : "Register"}
                    </Button>
                </div>
            </form>
        </FormProvider>
    );
};
